<template>
  <v-layout row wrap class="colored-background">
    <!-- HEADER -->
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <!-- CASE 1: CREATION -->
    <v-flex v-if="storeMode === 'creation'" xs12 sm12 md12 class="mt-4 text-xs-center">
      <span class="thank-you">Thank you for creating your account!</span>
    </v-flex>
    <v-flex v-if="storeMode === 'creation'" xs12 sm12 md12 class="mx-4 mt-4 text-xs-center">
      <span class="finalize-account">Go to your inbox to <span class="action">finalize your account</span>, then download and <span class="action">sign into the apps</span> to enjoy your free trial.</span>
    </v-flex>
    <!-- CASE 2: FINALIZATION -->
    <v-flex v-if="storeMode === 'finalization'" xs12 sm12 md12 class="mt-4">
      <center>
        <v-img width="48" :src="assetRoot + 'check.png'" />
      </center>
    </v-flex>
    <v-flex v-if="storeMode === 'finalization'" xs12 sm12 md12 class="mt-3 text-xs-center">
      <span class="account-creation-for">Account creation for:<br /><span class="email">{{ email }}</span></span>
    </v-flex>
    <v-flex v-if="storeMode === 'finalization'" xs12 sm12 md12 class="mt-4 text-xs-center">
      <span class="thank-you">Your account<br /> was successfully<br /> finalized!</span>
    </v-flex>
    <v-flex v-if="storeMode === 'finalization'" xs12 sm12 md12 class="mx-4 mt-5 text-xs-center">
      <span class="finalize-account">You can now <span class="action">download</span> and<br /> <span class="action">sign into the apps</span> to enjoy<br /> your free trial.</span>
    </v-flex>
    <!-- APPS -->
    <v-flex xs12 sm12 md12 class="mt-5">
      <store-apps store_mode="store" />
    </v-flex>
    <!-- BOTTOM HOLDER -->
    <v-flex xs12 sm12 md12 class="bottom-holder my-3"> </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  import StoreApps from './StoreApps'

  export default {
    components: {
      'store-apps': StoreApps
    },
    data () {
      return {

      }
    },
    methods: {

    },
    computed: {
      ...mapGetters([
        'assetRoot',
        'storeMode',

        'email'
      ])
    },
    mounted () {
      this.$nextTick(function () {

      })
    }
  }
</script>

<style scoped>

.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.thank-you {
  font-family: CenturyGothic;
  font-size: 35px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.finalize-account {
  font-family: CenturyGothic;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.finalize-account .action {
  color: #2c7fff;
}

.account-creation-for {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.account-creation-for .email {
  font-weight: bold;
  color: #7dff00;
}

.bottom-holder {
  height: 1px;
}

</style>
